import StyledFoot from "./Foot.Module";


function Foot() {
  return (
    <StyledFoot>
      <section>
          <div>
              <h2>Covid ID</h2>
          </div>

        
    </section>
    </StyledFoot>
    

  );
}

export default Foot;
